module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@3x-5c80d8eb75cf7d1e0a6f4f8f116a0213.png";